// Provided solution from svggator on stopping single play through svgs from repeating

// id for graphic-desert-walker.svg
document.getElementById('ewUOKrkm7bQ1')?.svgatorPlayer.ready(
    player => player.on('end', () =>
        player.on('play,restart', () => player.pause().seek(100)))
);